import { render } from "./GoogleTranslator.vue?vue&type=template&id=414e9497&scoped=true"
import script from "./GoogleTranslator.vue?vue&type=script&lang=js"
export * from "./GoogleTranslator.vue?vue&type=script&lang=js"

import "./GoogleTranslator.vue?vue&type=style&index=0&id=414e9497&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414e9497"]])

export default __exports__